import React from 'react';
import styled from 'styled-components';
import SharedPageLayout from './SharedPageLayout';
import ReliefClimatMap from './ReliefClimatMap';
import { theme } from '../theme';

const ReliefClimatMainSection = styled.section`
  width: 100%;
  padding: 20px 5% 80px 5%;

  @media (max-width: 768px) {
    padding: 15px 4% 60px 4%;
  }

  @media (max-width: 480px) {
    padding: 10px 3% 40px 3%;
  }
`;

const ReliefClimatMainContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 60px;

  @media (max-width: 768px) {
    gap: 40px;
  }

  @media (max-width: 480px) {
    gap: 32px;
  }
`;

const SectionTitle = styled.h2`
  font-family: ${theme.fonts.title};
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
  color: ${theme.colors.outchou_blue};
  text-align: center;
  margin: 0 0 20px 0;

  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 36px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

const SectionDescription = styled.p`
  font-family: ${theme.fonts.body};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.gray};
  text-align: center;
  margin: 0 0 40px 0;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  text-align: justify;

  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 21px;
  }
`;

const MapSection = styled.div`
  margin-top: 0;
`;

const ReliefClimatPage: React.FC = () => {
  return (
    <SharedPageLayout 
      heroType="search"
      backgroundImage="/shared_assets/images/navigation/relief-climat.jpeg"
      heroTitle="Relief & Climat"
      heroSubtitle="Structuré en bandes allant de la Méditerranée au Sahara, le relief algérien forme quatre grandes régions aux climats contrastés."
    >
      <ReliefClimatMainSection>
      <MapSection>
          <SectionTitle>Cliquez sur une zone colorée pour en savoir plus.</SectionTitle>
            <ReliefClimatMap />
          </MapSection>
      </ReliefClimatMainSection>
    </SharedPageLayout>
  );
};

export default ReliefClimatPage;